module.exports = __webpack_public_path__ + "img/logo.316311e3.svg";